<template>
  <button
    type="submit"
    class="button"
    :class="[color, { loading, block }]"
    :disabled="disabled"
  >
    <div class="whitespace-nowrap button__content">
      <i v-if="responsive" class="uil uil-trash-alt md:hidden"></i>
      <div :class="{ responsive }" v-if="!loading">
        {{ label }}
      </div>
      <i class="uil uil-spinner-alt animate_login" v-else></i>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    responsive: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
      validator: function (value) {
        return ["primary", "warning", "danger"].indexOf(value) !== -1;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  @apply text-white;
  @apply block;
  @apply text-base;
  @apply font-semibold;
  @apply tracking-wide;
  @apply w-full;
  @apply py-3;
  @apply px-8;
  @apply text-center;
  @apply rounded-lg;
  @apply outline-none;
  @apply select-none;
  @apply transition-all;
  @apply duration-200;
  @apply transform;

  &__content {
    @apply flex;
    @apply items-center;
    @apply justify-center;
    @apply gap-2;
  }

  &:hover:not(:disabled) {
    @apply -translate-y-px;
  }

  &:active:not(:disabled) {
    @apply translate-y-0;
    @apply scale-95;
  }

  &:focus-visible {
    @apply ring;
    @apply ring-offset-2;
    @apply ring-opacity-50;
  }

  &:disabled {
    @apply cursor-not-allowed;
    @apply shadow-none;
    @apply transform-none;
    &:hover {
      @apply cursor-not-allowed;
    }
  }
}

.animate_login {
  @apply inline-block;
  @apply animate-spin;
}

.primary {
  @apply bg-gignetblue-400;
  @apply shadow-gignetblue-400-md;
  &:disabled {
    @apply bg-gignetblue-200;
    &:hover {
      @apply bg-gignetblue-200;
    }
  }
  &:hover:not(:disabled) {
    @apply bg-gignetblue-500;
    @apply shadow-gignetblue-400-lg;
  }
  &:active {
    @apply bg-gignetblue-500;
  }
  &:focus-visible {
    @apply ring-gignetblue-300;
  }
}

.responsive {
  @apply inline-block;
  @apply invisible;
  font-size: 0px;
  @screen md {
    @apply visible;
    @apply text-base;
  }
}

.danger {
  @apply bg-red-400;
  @apply shadow-red-400-md;
  &:disabled {
    @apply bg-red-200;
    &:hover {
      @apply bg-red-200;
    }
  }
  &:hover:not(:disabled) {
    @apply bg-red-500;
    @apply shadow-red-400-lg;
  }
  &:active {
    @apply bg-red-500;
  }
  &:focus-visible {
    @apply ring-red-300;
  }
}
.loading {
  @apply bg-gignetblue-300 #{!important};
  @apply cursor-not-allowed;
  @apply shadow-none;
}
</style>
